<mat-toolbar color="accent">Invoice Interactions</mat-toolbar>
<pr-interactions
  compact
  [enableScroll]="true"
  [interactions]="interactions$ | ngrxPush"
  (interactionAdded)="addInteraction($event)"
 />
